import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-rprt-create',
    templateUrl: './rprt-create.component.html',
    styleUrls: ['./rprt-create.component.scss']
})
export class RprtCreateComponent implements OnInit {

    constructor() { }

    data: any = {
        rptTitle: '',
        description: '',
        type: '0'
    }

    types: any = [{
        id: 1,
        type: 'Numeric'
    },
      {
            id: 2,
            type: 'Text'
        },
        {
            id: 3,
            type: 'Rupees'
        },
        {
            id: 4,
            type: 'Decimal'
        }]



    fields: any = [];

    fieldData: any = {
        title: '',
        type: '0',
        min: '',
        max: ''
    }
 
    ngOnInit(): void {
    }

    //numberOnly
    numberOnly(event: any): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    addFields() {
        this.fields.push({
            fieldTitle: this.fieldData.title,
            type: this.fieldData.type,
            min: this.fieldData.min,
            max: this.fieldData.max
        })
    }
}
